import React from 'react';
import PropTypes from 'prop-types';
import isSameDay from 'date-fns/is_same_day';
import isAfter from 'date-fns/is_after';
import isBefore from 'date-fns/is_before';
import isSameMonth from 'date-fns/is_same_month';
import { Day } from "./Day";
import cx from "../utils/styles";
import { buildMonthDaysWithAdditionalMonths } from "../utils/utils";
var isDayBlockedMin = function isDayBlockedMin(date, min) {
  return min && !isSameDay(date, min) && isBefore(date, min);
};
var isDayBlockedMax = function isDayBlockedMax(date, max) {
  return max && !isSameDay(date, max) && isAfter(date, max);
};
var isDayBlocked = function isDayBlocked(date, min, max) {
  return isDayBlockedMin(date, min) || isDayBlockedMax(date, max);
};
export var CalendarMonthView = function CalendarMonthView(_ref) {
  var month = _ref.month,
    onDayClick = _ref.onDayClick,
    selectedDay = _ref.selectedDay,
    min = _ref.min,
    max = _ref.max;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('days'),
    "data-t-id": "Calendar-components"
  }, buildMonthDaysWithAdditionalMonths(month).map(function (date) {
    return {
      date: date,
      isSelected: selectedDay && isSameDay(date, selectedDay),
      isBlocked: isDayBlocked(date, min, max),
      isOtherMonth: !isSameMonth(date, month)
    };
  }).map(function (_ref2) {
    var date = _ref2.date,
      isBlocked = _ref2.isBlocked,
      isOtherMonth = _ref2.isOtherMonth,
      isSelected = _ref2.isSelected;
    return /*#__PURE__*/React.createElement(Day, {
      className: {
        otherMonth: isOtherMonth,
        blockedDay: isBlocked,
        active: isSelected
      },
      date: date,
      key: "calday:".concat(date.toISOString()),
      onClick: isBlocked ? function () {
        return false;
      } : onDayClick
    });
  }));
};
CalendarMonthView.propTypes = process.env.NODE_ENV !== "production" ? {
  selectedDay: PropTypes.instanceOf(Date),
  month: PropTypes.instanceOf(Date).isRequired,
  onDayClick: PropTypes.func,
  min: PropTypes.instanceOf(Date),
  max: PropTypes.instanceOf(Date)
} : {};
CalendarMonthView.defaultProps = {
  selectedDay: undefined,
  min: undefined,
  max: undefined,
  onDayClick: function onDayClick() {
    return undefined;
  }
};